import styled from "styled-components";
import { List } from "discover.medical.react-component-library";

export const StyledItem = styled(List.Item)`
  ul &::before {
    top: 0.1rem;
  }
`;
